import { Injectable } from '@angular/core';
import { map } from 'rxjs/internal/operators/map';
import { LoginService } from '../login/login.service.ts.service';
import { HttpMethodsService } from '../_helpers/http-methods.service';
import { myAccountConstants } from './constants/my-account.constant';

@Injectable({
  providedIn: 'root'
})
export class MyAccountService {
  userId = sessionStorage.getItem('userId');
  FETCH_ACCOUNT_DETAIL_URL = myAccountConstants.USER_MGMNT_URL + this.userId;
  constructor(private httpMethodsservice: HttpMethodsService,
    private loginService: LoginService) { }
  
  updateAccountDetail(params) {
    return this.httpMethodsservice.patch(this.FETCH_ACCOUNT_DETAIL_URL, params)
      .pipe(map((res: any) => {
        return res;
      }
      ));
  }
  getUserAccountDetails() {
    return this.httpMethodsservice.get(this.FETCH_ACCOUNT_DETAIL_URL).pipe(map((res: any) => res));
  }
}
